/* with love from shopstory */
var styled = require('styled-components');
var React = require('react');
var index = require('./index-0b475274.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__namespace = /*#__PURE__*/_interopNamespace(React);

var __jsx = React__namespace.createElement;
var Preview = styled__default["default"].div.withConfig({
  displayName: "ThumbnailButton__Preview",
  componentId: "sc-bw2u19-0"
})(["display:flex;align-items:center;justify-content:center;margin-left:-1px;width:32px;height:32px;border:1px solid #e5e5e5;border-radius:2px;position:relative;min-width:0;"]);
var PreviewImage = styled__default["default"].img.withConfig({
  displayName: "ThumbnailButton__PreviewImage",
  componentId: "sc-bw2u19-1"
})(["display:block;max-width:100%;max-height:100%;object-fit:contain;"]);
var SolidColorPreview = styled__default["default"].div.withConfig({
  displayName: "ThumbnailButton__SolidColorPreview",
  componentId: "sc-bw2u19-2"
})(["width:100%;height:100%;background-color:", ";"], function (_ref) {
  var color = _ref.color;
  return color;
});
var ContentRoot = styled__default["default"].div.withConfig({
  displayName: "ThumbnailButton__ContentRoot",
  componentId: "sc-bw2u19-3"
})(["display:flex;align-items:center;gap:8px;width:100%;"]);
var Labels = styled__default["default"].div.withConfig({
  displayName: "ThumbnailButton__Labels",
  componentId: "sc-bw2u19-4"
})(["flex:1 0;overflow:hidden;min-width:0;"]);
function ThumbnailButton(_ref2) {
  var onClick = _ref2.onClick,
      label = _ref2.label,
      description = _ref2.description,
      thumbnail = _ref2.thumbnail,
      disabled = _ref2.disabled;
  var preview;

  if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "image") {
    preview = __jsx(PreviewImage, {
      src: thumbnail.src,
      "aria-hidden": "true"
    });
  } else if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "color") {
    preview = __jsx(SolidColorPreview, {
      color: thumbnail.color
    });
  } else if ((thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.type) === "icon") {
    preview = __jsx(thumbnail.icon, {
      size: 16
    });
  } else {
    preview = __jsx(SolidColorPreview, {
      color: "transparent"
    });
  }

  var content = __jsx(ContentRoot, null, __jsx(Preview, null, preview), __jsx(Labels, null, label && __jsx(index.Typography, {
    variant: "label"
  }, label), description && __jsx(index.Typography, {
    variant: "body",
    color: "black40"
  }, description)));

  if (disabled) {
    return __jsx(ContentRoot, null, content);
  }

  return __jsx("div", {
    style: {
      display: "grid",
      width: "100%"
    }
  }, __jsx(index.SSButtonGhost, {
    onClick: onClick,
    height: "32px",
    noPadding: true
  }, content));
}

exports.ThumbnailButton = ThumbnailButton;
